module.exports = __webpack_public_path__ + "fromGroomToParents-we-g.967b6484.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToParents-we-g.jpg
// module id = trX4
// module chunks = 0